import { ApiClient } from "@common/services/ApiClient"
import configProvider from "@common/services/configProvider"
import userManager from "../userManager"

export default new ApiClient(configProvider.get("CORE_API_WORKER_PATH") || "core-api-worker", undefined, options => {
    options.requestInterceptor = req => {
        const tenantCode = userManager.tenantCode()
        if (tenantCode) {
            req.headers["x-tenant-code"] = tenantCode
        }
    }
    return options
}, params => {
    const tenantCode = userManager.tenantCode()
    if (tenantCode) {
        params.x_tenant_code = tenantCode
    }
    return params
})
